<template>
  <FetchJson :url="url">
    <template #default="{ json, loading }">
      <InfoBlock v-if="!loading">
        <template v-slot:header>Количество направленных заявлений</template>
        <template v-slot:default>
          <BaseTable :columns="columns">
            <template #rows>
              <tr
                v-for="(row, indx) in json.values"
                :key="indx"
                class="table__tr"
              >
                <td class="table__td">{{ row.applicationKind }}</td>
                <td class="table__td">{{ row.applicationsTotal }}</td>
                <td class="table__td">{{ row.mfc }}</td>
                <td class="table__td">{{ row.pgu }}</td>
                <td class="table__td">{{ row.other }}</td>
              </tr>
            </template>
          </BaseTable>
        </template>
      </InfoBlock>
    </template>
  </FetchJson>
</template>

<script>
import { toRefs, computed } from "vue";
import { dateToString } from "@/modules/date";

export default {
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const filter = toRefs(props.filter);
    const url = computed(
      () =>
        `applications/send-method-by-kind?from=${dateToString(
          filter.from.value
        )}&to=${dateToString(filter.to.value)}&territory=${
          filter.territory.value.alias || ""
        }`
    );
    const columns = [
      "Вид заявления",
      "Всего заявлений",
      "МФЦ",
      "ПГУ",
      "Остальные",
    ];

    return {
      url,
      columns,
    };
  },
};
</script>

<style lang="scss">
</style>
